
import { mapState, mapGetters, mapActions } from "vuex";
import Highlighter from "vue-highlight-words";
import ProfileMenuV2 from "~/components/v2/common/profiles/profile-menu-v2.vue";
import { formatDate } from "~/common/helpers";

export default {
  name: "Photobank",

  components: { Highlighter, ProfileMenuV2 },

  data() {
    return {
      route: this.$route.name,

      searchName: "",
      loading: false,
      dateFormatOptions: {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      },
      searchIntervalId: null,
      isFavoriteProcessing: false,
      gender: "",
      district: "",
    };
  },

  async fetch({ store }) {
    await store.commit("photobank/resetFilters");
    const globalGender = store.getters["global/getCurrentGender"] || "female";
    await store.commit("photobank/setFilter", {
      key: "gender",
      value: globalGender,
    });
    await store.dispatch("photobank/getPhoto", { page: 1 });
  },

  head() {
    return {
      title: this.processedSeoTexts?.title || "Emiratescort Photobank",
      link: [
        {
          rel: "canonical",
          href: `${this.$config.baseUrlApp}/escorts-photo-gallery`,
        },
      ],
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.processedSeoTexts?.description || "",
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.processedSeoTexts?.description || "",
        },
        {
          hid: "og:title",
          name: "og:title",
          content: this.processedSeoTexts?.title || "Emiratescort photobank",
        },
        {
          property: "og:image",
          hid: "og:image",
          name: "og:image",
          content: "https://erowall.com/wallpapers/large/3156.jpg",
        },
      ],
    };
  },

  mounted() {
    this.gender = this.$store.getters["global/getCurrentGender"] || "female";
    this.district = "";
  },

  computed: {
    ...mapState(["photobank"]),

    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      gallery: "photobank/getGallery",
      countPhotos: "photobank/getCountPhotos",
      lastPage: "photobank/getLastPage",
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
      search: "photobank/getSearch",
      processedSeoTexts: "global/getProcessedSeoTexts",
      currentGenderFilter: "photobank/getGenderFilter",
      currentDistrictFilter: "photobank/getDistrictFilter",
    }),

    h1() {
      return this.processedSeoTexts?.h1 || this.$t("photobank");
    },

    isMobile() {
      return this.$store.state.global.mobile;
    },

    percentage() {
      return (this.gallery.length * 100) / this.countPhotos;
    },

    filterObj() {
      const districts =
        this.filtersList?.districts?.filter(
          (district) => district.city_id == this.currentCity.id
        ) || [];

      return {
        district: {
          items: districts,
          title: this.$t("area"),
        },
        gender: {
          items: [
            { title: this.$t("female"), id: "female" },
            { title: this.$t("shemale"), id: "transgender" },
            { title: this.$t("male"), id: "male" },
          ],
          title: this.$t("gender"),
        },
      };
    },

    districtsDroplistV2() {
      return [
        ...[
          {
            title: this.$t("all-areas"),
            value: "",
          },
        ],
        ...(this.filterObj.district.items?.map((item) => {
          return {
            title: item.title,
            value: item.id,
          };
        }) || []),
      ];
    },

    genderDroplistV2() {
      return (
        this.filterObj.gender.items?.map((item) => {
          return {
            title: item.title,
            value: item.id,
          };
        }) || []
      );
    },
  },

  methods: {
    ...mapActions({
      addToFafourites: "profiles/addToFafourites",
      removeFromFavourites: "profiles/removeFromFavourites",
    }),

    async processFavorite(photo, index) {
      this.isFavoriteProcessing = true;
      try {
        let response;
        if (photo.in_favorites) {
          response = await this.removeFromFavourites(photo.profile.id);
          this.$store.commit("photobank/setFavoriteById", {
            id: photo.id,
            isFavorite: false,
          });
        } else {
          response = await this.addToFafourites(photo.profile.id);
          if (response.data.status) {
            this.$store.commit("photobank/setFavoriteById", {
              id: photo.id,
              isFavorite: true,
            });
          }
        }

        if (!response.data.status) {
          this.$notify({
            type: "warning",
            message: response.data.msg,
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isFavoriteProcessing = false;
      }
    },

    async showMoreProfiles() {
      this.loading = true;
      await this.$store.dispatch("photobank/supplementPhoto");
      this.loading = false;
    },

    photosFilterModifier() {
      this.$store.commit("global/setPhotosFilter");
    },

    setFilterMobile(data) {
      for (let key in data) {
        const value = data[key];
        if (value) {
          this.$store.commit("photobank/setFilter", { key, value });
        }
      }
    },

    searchByName(key, value) {
      if (this.searchIntervalId) {
        clearTimeout(this.searchIntervalId);
      }
      this.searchName = value;
      this.searchIntervalId = setTimeout(() => {
        if (value == "") value = null;
        this.$store.commit("photobank/setFilter", { key: "search", value });
        this.$store.dispatch("photobank/getPhoto", { page: 1 });
      }, 500);
    },

    formattedDate(date) {
      return (
        this.$t("added") +
        " " +
        formatDate(this.$i18n.locale, date, this.dateFormatOptions)
      );
    },

    async onFilterChange(value, key) {
      this.$store.commit("photobank/setFilter", { key, value });
      await this.$store.dispatch("photobank/getPhoto", { page: 1 });
    },
  },
};
